import FormViewForm from '@src/components/_forms/FormViewForm';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import TechOperationItemsField from '@views/tech-operations/fields/TechOperationItemsField';

const customFields = {
    items: {
        component: TechOperationItemsField,
    },
};

export default class TechOperationsForm<Model extends IClientModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields as any;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'type') {
            return this.mutateTypeFieldInitialValue(modelValue);
        }

        if (fieldName === 'items') {
            return this.mutateItemsFieldInitialValue(modelValue);
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    protected mutateTypeFieldInitialValue(value: any) {
        return value ?? 'default';
    }

    protected mutateItemsFieldInitialValue(value: any) {
        if (!Array.isArray(value)) {
            return [];
        }

        const pluckIds = (collection: { id: string | number }[]): (string | number)[] => {
            return collection.map(item => item.id);
        };

        return value.map((item: Record<any, any>) => {
            return {
                ...item,
                operations: pluckIds(item.operations),
                materials: pluckIds(item.materials),
                material_categories: pluckIds(item.material_categories),
            };
        });
    }
}
